// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3mqyN","errors":"Errors_errors__2px6T"};